<script setup lang="ts">
import { onMounted, onUnmounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useToastStore } from '@/stores/toast'
import Toast from 'primevue/toast'
import AppTopBar from '@/components/AppTopBar.vue'
import AppSideBar from '@/components/AppSideBar.vue'

const auth = useAuthStore()
const toast = useToastStore()
const route = useRoute()
const router = useRouter()

const showShell = computed(() => auth.isAuthenticated && !route.meta.hideShell)

function onAuthLogout(): void {
  auth.logout()
  toast.info('Session expired', 'Please log in again.')
  router.push({ name: 'login' })
}

onMounted(async () => {
  window.addEventListener('auth:logout', onAuthLogout)
  if (auth.isAuthenticated && !auth.user) {
    await auth.refreshUser()
  }
})

onUnmounted(() => {
  window.removeEventListener('auth:logout', onAuthLogout)
})

function handleLogout(): void {
  auth.logout()
  router.push({ name: 'login' })
}
</script>

<template>
  <div class="app-shell" :class="{ 'image-shell': route.path.startsWith('/image-tasks/') }">
    <Toast />
    <AppTopBar v-if="showShell" :user="auth.user" @logout="handleLogout" />
    <div class="layout">
      <AppSideBar v-if="showShell" />
      <main class="content">
        <RouterView />
      </main>
    </div>
  </div>
</template>
